import { render, staticRenderFns } from "./JsonTable.vue?vue&type=template&id=03f39d77&scoped=true"
import script from "./JsonTable.vue?vue&type=script&lang=js"
export * from "./JsonTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f39d77",
  null
  
)

export default component.exports